import React from "react";
import { Navigate } from "react-router-dom";

const SriMailLogComponent = React.lazy(
  () => import("../../../../../components/logs/components/sri-mails/page"),
);

export const mailLogRoutes = [
  {
    path: "list",
    element: <SriMailLogComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/sri/mail-log/list" />,
  },
];
